<div class="p-3 d-flex flex-column justify-content-center align-items-center">
  <div class="mb-3 dialog-icon-wrapper w-100 d-flex align-items-center justify-content-between">
    @if (icon) {
      <svg-icon
        class="dialog-icon d-flex align-items-center"
        [class.text-danger]="level === 'danger'"
        [class.text-warning]="level === 'warning'"
        [ngClass]="level === 'normal' && page ? 'text-' + page : ''"
        [name]="icon"
      ></svg-icon>
    }
    <button
      (click)="modal.dismiss()"
      class="btn btn-icon-light p-1 ms-auto"
      >
      <svg-icon
        class="close-icon cs-svg-icon-contained cs-svg-icon-centered"
        name="close"
      ></svg-icon>
    </button>
  </div>

  @if (title) {
    <div
      class="mb-3 d-flex align-items-center justify-content-start w-100"
      >
      <h4
        class="text-start m-0"
        [class.fw-bold]="title && text"
      >{{ title }}</h4>
    </div>
  }

  @if (text) {
    <div
      class="mb-3 text-start w-100"
      [class.text-error]="level === 'danger'"
      [class.text-warning]="level === 'warning'"
      [innerHtml]="text"
    ></div>
  }

  <div class="w-100 d-flex align-items-center justify-content-end">
    <button
      type="button"
      class="btn ms-auto"
      [ngClass]="'btn-' + themeColor"
      (click)="modal.close()"
      autofocus
      >
      {{ confirmText }}
    </button>
  </div>
</div>
